import {
  EHeadingStyleVariant,
  ELinkVariant,
  ETextStyleVariant,
  Heading,
  Link,
  Text,
} from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import spotlightLatestNews from '@/assets/about/outdoorsy-group/spotlight-latest-news.jpg';
import MaxWidth from '@/components/common/layout/MaxWidth';
import { useBreakpoint } from '@/hooks/useBreakpoint';

const LatestNewsSpotlight = () => {
  const intl = useIntl();
  const { isMobile, isAboveTablet, isAboveDesktop } = useBreakpoint();

  let articleHeadingVariant = EHeadingStyleVariant.H6;

  if (isAboveTablet) {
    articleHeadingVariant = EHeadingStyleVariant.H5;
  }

  if (isAboveDesktop) {
    articleHeadingVariant = EHeadingStyleVariant.H4;
  }

  return (
    <section className="px-6 py-14 md:py-24">
      <MaxWidth className="justify-center px-0 mx-auto">
        <Heading
          className="pb-4 lg:pb-8"
          variant={isMobile ? EHeadingStyleVariant.H4Alt : EHeadingStyleVariant.H3Alt}>
          <FormattedMessage defaultMessage="Latest news" id="P0HF+H" />
        </Heading>
        <div className="flex flex-col gap-x-14 md:flex-row">
          <div className=" w-full max-w-[380px]">
            <Image
              src={spotlightLatestNews}
              alt="spotlight news image"
              role="presentation"
              width={0}
              height={0}
              style={{ width: '100%', height: '100%' }}
              layout="responsive"
              objectFit="contain"
              loading="lazy"
            />
          </div>
          <div className="content-center">
            <div className="flex items-center px-2 py-1 text-white bg-red-300 rounded w-fit">
              <span className="mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7"
                  height="6"
                  viewBox="0 0 7 6"
                  fill="none">
                  <circle cx="3.49233" cy="2.90792" r="2.83077" fill="white" />
                </svg>
              </span>

              <Text>
                <FormattedMessage defaultMessage="LATEST" id="Q0Xhj4" />
              </Text>
            </div>
            <Heading className="py-4 max-w-[609px]" variant={articleHeadingVariant}>
              <FormattedMessage
                defaultMessage="The Outdoorsy Group Exceeds $3 Billion in Sales, Plans European Expansion"
                id="u1mH6Q"
              />
            </Heading>
            <Link
              href="https://www.prnewswire.com/news-releases/the-outdoorsy-group-exceeds-3-billion-in-sales-plans-european-expansion-302255696.html"
              target="blank"
              variant={ELinkVariant.Underline}
              textVariant={ETextStyleVariant.LargeLink}
              label={intl.formatMessage({ defaultMessage: 'Read more', id: 'S++WdB' })}
            />
          </div>
        </div>
      </MaxWidth>
    </section>
  );
};

export default LatestNewsSpotlight;
